/**
 * Transforms the flat frontend state object into the strict array format expected by the backend.
 * 
 * @param {string} qrToken 
 * @param {Object} answers - Flat state object (e.g., { "1": 5, "3": "Great" })
 * @param {Array} questions - Array of question objects from the API
 * @returns {Object} Payload structured for the backend
 */
export const transformFeedbackPayload = (qrToken, answers, questions) => {
  const responses = Object.keys(answers).map(questionIdStr => {
    const questionId = parseInt(questionIdStr, 10);
    const rawAnswer = answers[questionIdStr];
    
    // Find the corresponding question to know its type
    const question = questions.find(q => q.id === questionIdStr);
    
    let rating = null;
    let response_text = null;
    
    if (question && question.type === 'rating') {
      rating = parseInt(rawAnswer, 10);
      if (isNaN(rating)) rating = null;
    } else {
      // Treat as text response
      response_text = rawAnswer ? String(rawAnswer) : null;
    }
    
    return {
      question_id: questionId,
      rating,
      response_text
    };
  });
  
  return {
    qr_token: qrToken,
    responses
  };
};
